import {CLOSE_VIDEO, PLAY_VIDEO, PLAY_HEADER_VIDEO, PLAY_LESSON_VIDEO, PAUSE_HEADER_VIDEO, PAUSE_LESSON_VIDEO} from '../actions/type'

const INITIAL_STATE = {
    modal_open: false,
    url: '',
    header_video_playing: false,
    header_video_paused: false,
    lesson_video_playing: false,
    lesson_video_paused: false
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PLAY_VIDEO:
            return {
                ...state,
                url: action.payload,
                modal_open: true,
            }
        case CLOSE_VIDEO:
            return {
                ...state,
                url: '',
                modal_open: false,
            }
        case PLAY_HEADER_VIDEO:
            return {
                ...state,
                header_video_playing: action.payload,
                header_video_paused: !action.payload,
                lesson_video_playing: false,
            }
        case PLAY_LESSON_VIDEO:
            return {
                ...state,
                lesson_video_playing: action.payload,
                lesson_video_paused: !action.payload,
                header_video_playing: false,
            }
        case PAUSE_HEADER_VIDEO:
            return {
                ...state,
                header_video_playing: false,
                header_video_paused: true
            }
        case PAUSE_LESSON_VIDEO:
            return {
                ...state,
                lesson_video_playing: false,
                lesson_video_paused: true
            }
        default:
            return state
    }
}
